// extracted by mini-css-extract-plugin
export var subtitle = "FlybusScheduleTable-module--subtitle--13SKq";
export var table = "FlybusScheduleTable-module--table--3thOR";
export var thContainer = "FlybusScheduleTable-module--thContainer--2CTmG";